import React, { useContext } from "react";
import style from "./index.module.scss";
import moment from "moment";
import LiveSignLog from "./components/LiveSignLog";
import { isTrue } from "service/service";
import { CourseContext } from "../Store";

export default function SignIn() {
    const { course } = useContext(CourseContext);

    const { date, courseNo, courseSeq, section, week, day, channelId, isLive } =
        course;

    return (
        <div className={style.root}>
            {isTrue(isLive) && (
                <LiveSignLog
                    date={moment(date)}
                    courseNo={courseNo}
                    courseSeq={courseSeq}
                    section={section}
                    week={day}
                    weekTime={week}
                    channelId={channelId}
                />
            )}
        </div>
    );
}
